import { PENDING_TABLE_PER_PAGE } from './pendingTableConfig';

const MOBILE_SKELETON_CARDS = 4;

/** 待办列表首屏加载占位：桌面对齐表格行，手机对齐订单卡片 */
const PendingListLoadingState = () => (
	<div className='pending-list-loading' role='status' aria-live='polite' aria-label='加载待办列表'>
		<div className='pending-list-loading__desktop'>
			<div className='pending-list-loading__head' aria-hidden='true'>
				<span className='pending-list-loading__skeleton pending-list-loading__skeleton--head' />
				<span className='pending-list-loading__skeleton pending-list-loading__skeleton--head' />
				<span className='pending-list-loading__skeleton pending-list-loading__skeleton--head pending-list-loading__skeleton--narrow' />
				<span className='pending-list-loading__skeleton pending-list-loading__skeleton--head' />
				<span className='pending-list-loading__skeleton pending-list-loading__skeleton--head' />
				<span className='pending-list-loading__skeleton pending-list-loading__skeleton--head pending-list-loading__skeleton--narrow' />
				<span className='pending-list-loading__skeleton pending-list-loading__skeleton--head pending-list-loading__skeleton--narrow' />
			</div>
			{Array.from({ length: PENDING_TABLE_PER_PAGE }, (_, index) => (
				<div key={index} className='pending-list-loading__row' aria-hidden='true'>
					<span className='pending-list-loading__skeleton pending-list-loading__skeleton--primary' />
					<span className='pending-list-loading__skeleton' />
					<span className='pending-list-loading__skeleton pending-list-loading__skeleton--narrow' />
					<span className='pending-list-loading__skeleton pending-list-loading__skeleton--sm' />
					<span className='pending-list-loading__skeleton pending-list-loading__skeleton--sm' />
					<span className='pending-list-loading__skeleton pending-list-loading__skeleton--sm' />
					<span className='pending-list-loading__skeleton pending-list-loading__skeleton--sm' />
				</div>
			))}
		</div>
		<div className='pending-list-loading__mobile' aria-hidden='true'>
			{Array.from({ length: MOBILE_SKELETON_CARDS }, (_, index) => (
				<article key={index} className='pending-list-loading__card'>
					<div className='pending-list-loading__card-header'>
						<div className='pending-list-loading__card-heading'>
							<div className='pending-list-loading__card-title-row'>
								<span className='pending-list-loading__skeleton pending-list-loading__skeleton--card-title' />
								<span className='pending-list-loading__skeleton pending-list-loading__skeleton--badge' />
							</div>
							<span className='pending-list-loading__skeleton pending-list-loading__skeleton--card-subtitle' />
						</div>
						<span className='pending-list-loading__skeleton pending-list-loading__skeleton--action' />
					</div>
					<div className='pending-list-loading__card-body'>
						<div className='pending-list-loading__card-field'>
							<span className='pending-list-loading__skeleton pending-list-loading__skeleton--label' />
							<span className='pending-list-loading__skeleton pending-list-loading__skeleton--value' />
						</div>
						<div className='pending-list-loading__card-field'>
							<span className='pending-list-loading__skeleton pending-list-loading__skeleton--label pending-list-loading__skeleton--label-wide' />
							<span className='pending-list-loading__skeleton pending-list-loading__skeleton--value pending-list-loading__skeleton--value-wide' />
						</div>
						<div className='pending-list-loading__card-field'>
							<span className='pending-list-loading__skeleton pending-list-loading__skeleton--label' />
							<span className='pending-list-loading__skeleton pending-list-loading__skeleton--value pending-list-loading__skeleton--value-short' />
						</div>
					</div>
				</article>
			))}
		</div>
		<span className='visually-hidden'>加载中</span>
	</div>
);

export default PendingListLoadingState;
